import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import FormModal from './FormModal';
import { deFlagRoof } from '../../redux/slices/roofsSlice';
import { confirmationStyle } from './config';
import { useTranslation } from 'react-i18next';
import '../../css/addRoofForm.css';

const DeFlagConfirmationModal = ({ open, onClose, roof }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector(state => state.auth); 

    const handleOnSubmit = async (event) => {
        event.preventDefault();
        try {
            await dispatch(deFlagRoof(({"roof":roof, "user_info": user}))).unwrap();
            onClose();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <FormModal
            id='flag'
            isOpen={open}
            onCancel={() => onClose()}
            onSubmit={handleOnSubmit}
            contentstyle={confirmationStyle}
        >
            <h4>{t('confirmation.deflag')}</h4>
        </FormModal>
    )
}

export default DeFlagConfirmationModal